<template>
    <div>
        <iframe width="100%" height="600px" src= "/Content/Okko/story_html5.html" ref="frame"/>
    </div>
</template>

<script>
    export default {
        name: "test-okko",

        data() {
            return {

            }
        },

        mounted(){
            this.$refs['frame'].height = $('.page-content').height();
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/views/details/TestOkko.vue